import { render, staticRenderFns } from "./wtDropdownView.component.vue?vue&type=template&id=76201842&"
import script from "./wtDropdownView.component.vue?vue&type=script&lang=js&"
export * from "./wtDropdownView.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports